/* eslint-disable */
export const TimeUtils = {
    MINUTES_TO_MILIS: 60000,
    options: { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "2-digit" },
    announcementOptions: { year: "numeric", month: "numeric", day: "numeric" },

    // Obsługuje zmianę strefy czasowej, ponieważ komponent kalendarz z Primevue tego nie robi.
    adjustTimezone(dateTime) {
        const dt = (dateTime instanceof Date) ? dateTime : new Date(dateTime);
        return new Date(dt.getTime() - (dt.getTimezoneOffset() * this.MINUTES_TO_MILIS));
    },

    // Zmienia request body (DTO lub SearchCriteria) tak, aby można było poprawnie wykonywać operacje
    // dotyczące czasu (wyszukiwanie, zapisywanie do bazy danych).
    adjustRequestBody(request) {
        const newRequest = {...request};
        if (newRequest.outageStart) {
            newRequest.outageStart = this.adjustTimezone(newRequest.outageStart);
        } else if (newRequest.start) {
            newRequest.start = this.adjustTimezone(newRequest.start);
        } else if (newRequest.creationDate) {
            newRequest.creationDate = this.adjustTimezone(newRequest.creationDate);
        }
        if (newRequest.outageEnd) {
            newRequest.outageEnd = this.adjustTimezone(newRequest.outageEnd);
        } else if (newRequest.end) {
            newRequest.end = this.adjustTimezone(newRequest.end);
        }
        if (newRequest.outageAnnouncement) {
            newRequest.outageAnnouncement = this.adjustTimezone(newRequest.outageAnnouncement);
        }
        if (Array.isArray(newRequest.outageReportTimes)) {
            newRequest.outageReportTimes = newRequest.outageReportTimes.map((item) => ({
                ...item,
                outageStart: item.outageStart
                    ? this.adjustTimezone(item.outageStart)
                    : item.outageStart,
                outageEnd: item.outageEnd
                    ? this.adjustTimezone(item.outageEnd)
                    : item.outageEnd,
            }));
        }
        return newRequest;
    },

    adjustResponseBody(report) {
        if (report.outageStart) {
            report.outageStart = new Date(report.outageStart);
        }
        if (report.outageEnd) {
            report.outageEnd = new Date(report.outageEnd);
        }
        if (Array.isArray(report.outageReportTimes)) {
            report.outageReportTimes = report.outageReportTimes.map((item) => ({
                ...item,
                outageStart: item.outageStart
                    ? new Date(item.outageStart)
                    : item.outageStart,
                outageEnd: item.outageEnd
                    ? new Date(item.outageEnd)
                    : item.outageEnd,
            }));
        }
        if (report.outageAnnouncement) {
            report.outageAnnouncement = new Date(report.outageAnnouncement);
        }
        return report;
    }
};
